import { createSlice } from '@reduxjs/toolkit';
import { checkIfUserIsRegistered, registerUser } from './register-thunk';
import { AsyncStatus } from '../../constants/async-status';
import IRegister from '../../../core/utils/interfaces/register-interface';

const initialState = {
    checkIfUserIsRegisteredAsyncStatus: AsyncStatus.INITIAL,
    checkIfUserIsRegistered: null,
    registerUserAsyncStatus: AsyncStatus.INITIAL,
} as IRegister;

const registerSlice = createSlice({
    name: 'register',
    initialState,
    reducers: {},
    extraReducers(builder: any) {
        builder
            .addCase(checkIfUserIsRegistered.pending, (state: IRegister) => {
                state.checkIfUserIsRegisteredAsyncStatus = AsyncStatus.LOADING;
            })
            .addCase(
                checkIfUserIsRegistered.fulfilled,
                (state: IRegister, { payload }: any) => {
                    state.checkIfUserIsRegisteredAsyncStatus =
                        AsyncStatus.SUCCESS;
                    state.checkIfUserIsRegistered = payload;
                }
            )
            .addCase(checkIfUserIsRegistered.rejected, (state: IRegister) => {
                state.checkIfUserIsRegisteredAsyncStatus = AsyncStatus.FAILURE;
            })
            .addCase(registerUser.pending, (state: IRegister) => {
                state.registerUserAsyncStatus = AsyncStatus.LOADING;
            })
            .addCase(registerUser.fulfilled, (state: IRegister) => {
                state.registerUserAsyncStatus = AsyncStatus.SUCCESS;
            })
            .addCase(registerUser.rejected, (state: IRegister) => {
                state.registerUserAsyncStatus = AsyncStatus.FAILURE;
            });
    },
});

export default registerSlice.reducer;
